export default __webpack_public_path__ + "static/media/SAS0330.34I-41879_-25099_0.c6ac7d53.jpg";